// extracted by mini-css-extract-plugin
module.exports = {"ArrowsWrapper":"az_lrc","Arrow":"az_mrc","Visible":"az_nrc","Prev":"az_orc","Next":"az_prc","FlippedIcon":"az_qrc","PrevIcon":"az_rrc"};